import { inject, Injectable } from '@angular/core';

import { catchError, Observable, share, throwError } from 'rxjs';

import { ConfigService, SentryLogger } from '@fcom/core/services';
import { FinnairAirCalendarChangeListResponse, FinnairCalendarChangeRequest } from '@fcom/dapi/api/models';
import { retryWithBackoff } from '@fcom/rx';
import { LanguageService } from '@fcom/ui-translate';
import { mapErrorForSentry } from '@fcom/core';
import { DapiService } from '@fcom/dapi/api/dapi.service';
import { findAirCalendarChange } from '@fcom/dapi/api/offer-functions';

@Injectable()
export class OffersService {
  private configService = inject(ConfigService);
  private dapiService = inject(DapiService);
  private sentryLogger = inject(SentryLogger);
  private languageService = inject(LanguageService);

  static NUMBER_OF_RETRIES = 1;

  findAirCalendarChange$(
    orderId: string,
    hash: string,
    body: FinnairCalendarChangeRequest
  ): Observable<FinnairAirCalendarChangeListResponse> {
    const locale = this.languageService.localeValue;
    return this.dapiService
      .invoke$(findAirCalendarChange, this.configService.cfg.offersUrl, { orderId, hash, locale, body })
      .pipe(
        retryWithBackoff(OffersService.NUMBER_OF_RETRIES),
        catchError((err: unknown) => {
          this.sentryLogger.error('Error finding air calendar change offers', {
            error: mapErrorForSentry(err),
          });
          return throwError(() => err);
        }),
        share()
      );
  }
}
